module.exports = __webpack_public_path__ + "static/level1-a06f1be8a41a78cccb4a6f38d1f08671.png";